<template>
  <div :class="{'d-inline': inline}">
    <a @click.prevent="displayHelpPopover"><i class="far fa-question-circle"></i></a>
    <HelpPopover ref="helpPopover" :title="title" :placement="placement">
      <slot />
    </HelpPopover>
  </div>
</template>

<script>
export default {
  name: 'InlineHelpPopover',
  props: {
    title: {
      type: String,
      default: 'Help Tips'
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    displayHelpPopover(evt) {
      this.$refs.helpPopover.displayFromElement(evt.target)
    }
  }
}
</script>